import { Pipe, PipeTransform } from '@angular/core';
import { getTimeDifference } from 'src/app/shared/utils/utility.service';

/**
 * @description: This pipe is used to get the difference of 2 time stamps
 * and format time.
 *
 */

@Pipe({
  name: 'expireTimeFormat',
})
export class ExpireTimeFormatPipe implements PipeTransform {
  transform(value: number): string {
    const currentTime = Math.floor(new Date().getTime() / 1000);
    let remainingTime = getTimeDifference(currentTime, value);
    return `${remainingTime?.days
      .toString()
      .padStart(2, '0')}d ${remainingTime?.hours
      .toString()
      .padStart(2, '0')}hr ${remainingTime?.minutes
      .toString()
      .padStart(2, '0')}min`;
  }
}
